/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 05/12/2025
 */

import {USER_TYPE_MODEL} from "../../../enums/userTypeEnum";
import HeadTittle from "../../../components/HeadTittle";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {IconSave, IconSubmit} from "../../../components/buttons/IconButtons";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../components/StepperTabs/StepTab";
import {VIEW_TYPE} from "../../../enums/ViewType";
import {CompanyDocumentationApp} from "./Functionality/CompanyDocumentationApp";
import RequestTab from "./SubComponents/RequestTab";
import {TAB_PERMISSION_COMPANY_DOCUMENTATION, TABS_COMPANY_DOCUMENTATION} from "./Model/Model";
import {TABLES} from "../../../Apis/Tables";
import DocumentationHistoryTab from "../../Dashboard/Contractors/CompanyDocumentation/SubComponents/DocumentationHistoryTab";
import {STATUS_MODEL} from "../../../enums/statusEnum";
import React from 'react';
import {PROFILE_MODEL} from "../../DocumentationApprovalFlow/Model/Model";
import DivContainerBody from "../../../components/DivContainerBody";

const CompanyDocumentation = ({profile}) => {

    const {
        userId,
        userTypeId,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        t,
        permission,
        DEV,
        modified,
        setModified,
        manageRef,
        historyRef,
        handleSaveDraft,
        handleSubmitSave,
        documentationApproval,
        handleOnBack,
        period,
        titleName,
        setPeriod,
        setDocumentationApproval
    } = CompanyDocumentationApp({profile})
    return (
        <>
            <HeadTittle onBack={handleOnBack} hidden={profile === PROFILE_MODEL.COMPANY} name={titleName}>
                {TAB_PERMISSION_COMPANY_DOCUMENTATION(activeStep).SAVE[activeStep] && (
                    ([STATUS_MODEL.PENDING,STATUS_MODEL.DRAFT]?.includes(documentationApproval)
                        && period) &&
                    <ButtonAction
                        id='btn_cd_save_draft'
                        name='save_draft'
                        className='btn-icon-export'
                        Icon={IconSave}
                        splitName={false}
                        onClick={handleSaveDraft}
                    />
                )}
                {TAB_PERMISSION_COMPANY_DOCUMENTATION(activeStep).SUBMIT[activeStep] && (
                    ([STATUS_MODEL.PENDING,STATUS_MODEL.CHANGES_REQUESTED,STATUS_MODEL.DRAFT]?.includes(documentationApproval)
                        && period) &&
                    <ButtonAction
                        id='btn_cd_submit'
                        name='submit'
                        className='btn-icon-add'
                        Icon={IconSubmit}
                        splitName={false}
                        onClick={handleSubmitSave}
                    />
                )}
            </HeadTittle>
            {
                profile === PROFILE_MODEL.COMPANY
                    ?
                    <>
                        <StepperTabs
                            onlyTab={true}
                            disabled={false}
                            steps={steps}
                            activeStep={activeStep}
                            isStepOptional={() => {}}
                            setActiveStep={setActiveStep}
                            handleStepChange={handleStepChange}
                        >
                            <StepTab index={TABS_COMPANY_DOCUMENTATION.REQUEST.INDEX} activeStep={activeStep} view={VIEW_TYPE.LIST}>
                                {activeStep === TABS_COMPANY_DOCUMENTATION.REQUEST.INDEX && userTypeId && (
                                    <>
                                        <RequestTab
                                            t={t}
                                            DEV={DEV}
                                            permission={permission}
                                            userId={userId}
                                            modified={modified}
                                            setModified={setModified}
                                            documentationApproval={documentationApproval}
                                            ref={manageRef}
                                            profile={profile}
                                            period={period}
                                            setPeriod={setPeriod}
                                            setDocumentationApproval={setDocumentationApproval}

                                        />
                                    </>
                                )}
                            </StepTab>
                            <StepTab index={TABS_COMPANY_DOCUMENTATION.HISTORY.INDEX} activeStep={activeStep}>
                                {activeStep === TABS_COMPANY_DOCUMENTATION.HISTORY.INDEX && userTypeId && (
                                    <DocumentationHistoryTab
                                        historyModel={userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE
                                            ? TABLES.HISTORY_CONTRACTOR_IN_CHARGE_DOCUMENTATION_LEVEL
                                            : TABLES.HISTORY_SUPPLIER_IN_CHARGE_DOCUMENTATION_LEVEL}
                                        id={userId}
                                        historyRef={historyRef}
                                        noInformationTitle={'no_documentation_submitted'}

                                    />
                                )}
                            </StepTab>
                        </StepperTabs>
                    </>
                    :
                    <DivContainerBody>
                        <RequestTab
                            t={t}
                            DEV={DEV}
                            permission={permission}
                            userId={userId}
                            modified={modified}
                            setModified={setModified}
                            documentationApproval={documentationApproval}
                            ref={manageRef}
                            profile={profile}
                            period={period}
                            setPeriod={setPeriod}
                            setDocumentationApproval={setDocumentationApproval}
                        />
                    </DivContainerBody>
            }
        </>
    );
};

export default CompanyDocumentation
